import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import { Container, Reveal } from '@/components/ui'

interface TeamMember {
  name: string
  role: string
}

const TEAM_COLORS = [
  'from-yada-gold to-yada-olive',
  'from-yada-green to-yada-green-dark',
  'from-yada-olive to-yada-brown',
  'from-yada-brown to-yada-coffee',
]

export default function TeamGrid() {
  const { t } = useTranslation()
  const members = t('home.team.members', { returnObjects: true }) as TeamMember[]

  return (
    <section className="py-section-y px-section-x bg-surface-2" aria-labelledby="team-title">
      <Container>
        <div className="text-center mb-8">
          <span className="section-title__tagline inline-block mb-3">
            {t('home.team.tag')}
          </span>
          <h2
            id="team-title"
            className="section-title__title text-3xl md:text-4xl lg:text-5xl text-ink"
          >
            {t('home.team.title')}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-gap-cards">
          {members.map((member, idx) => (
            <Reveal key={idx} delay={idx * 0.08}>
              <div className="text-center group">
                <div
                  className={`w-32 h-32 mx-auto rounded-full bg-gradient-to-br ${TEAM_COLORS[idx % TEAM_COLORS.length]} flex items-center justify-center text-surface text-4xl font-bold shadow-yada-lg mb-4 group-hover:scale-105 transition-transform`}
                >
                  {member.name.charAt(0)}
                </div>
                <h3 className="font-bold text-ink mb-1">{member.name}</h3>
                <p className="text-sm text-ink-soft">{member.role}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-8">
          <Icon
            icon="lucide:users"
            className="text-primary opacity-30 mx-auto"
            style={{ fontSize: '1.5rem' }}
          />
        </div>
      </Container>
    </section>
  )
}